import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl, baseHeaders, storeId } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const addOnsApi = createApi({
  reducerPath: 'addOnsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['AddOns'],
  endpoints: (builder) => ({
    get: builder.query({
      query: ({ availabilities, page, perPage } = {}) => {
        const params = {}

        if (page) {
          params.page = page
        }

        if (perPage) {
          params.per_page = perPage
        }

        for (const [index, slug] of Object.entries(availabilities || [])) {
          params[`availabilities[${index}]`] = slug
        }

        return { url: `/stores/${storeId}/addons`, params }
      },
      providesTags: ['AddOns'],
    }),
    update: builder.mutation({
      query: (data) => {
        return {
          url: `addons/${data.id}`,
          method: 'PATCH',
          body: data,
        }
      },
      invalidatesTags: (results, error, { id }) => {
        return ['AddOns']
      },
    }),
    add: builder.mutation({
      query: (addon) => ({ url: 'addons', method: 'POST', body: addon }),
      invalidatesTags: (results, error, { id }) => {
        return ['AddOns']
      },
    }),
    delete: builder.mutation({
      query: (addon) => ({ url: `addons/${addon.id}`, method: 'DELETE' }),
      invalidatesTags: (results, error, { id }) => {
        return ['AddOns']
      },
    }),
  }),
})

export const { useGetQuery, useAddMutation, useDeleteMutation, useUpdateMutation } = addOnsApi

export default addOnsApi
